import moment from 'moment-timezone';

import {
    STATUS_OPEN,
    STATUS_PROGRESS,
    STATUS_COMPLETE,
    STATUS_DELETED
} from './../store/orders/actions';

export const getStatus = order => {
    if (order.completed_grading) {
        return STATUS_COMPLETE;
    }
    if (order.assigned && order.assigned_by_me) {
        return STATUS_PROGRESS;
    }
    if (!order.assigned) {
        return STATUS_OPEN;
    }
    return STATUS_DELETED;
};

const availableSorter = (a, b) => {
    return moment(a.pregrader_created_at).diff(moment(b.pregrader_created_at));
};

export const getNextNumber = (orderNumber, state) => {
    const order = state.orders[orderNumber];
    if (!order) {
        return null;
    }
    const avaiableOrderList = Object.values(state.orders).filter(o => {
        if (o.number === order.number) {
            return true;
        }
        const status = getStatus(o);
        return (status === STATUS_OPEN || status === STATUS_PROGRESS) && o.writer === order.writer;
    });
    if (avaiableOrderList.length <= 1) {
        return null;
    }
    const sortedAvailableNumbers = avaiableOrderList.sort(availableSorter).map(o => o.number);
    const index = sortedAvailableNumbers.indexOf(order.number);
    if (index === -1) {
        return null;
    }
    const nextIndex = index === (sortedAvailableNumbers.length + 1) ? 0 : (index + 1);
    return sortedAvailableNumbers[nextIndex];
};

export const getOrderUrl = (orderNumber, state) => {
    const defaultLink = `/findorders/all/${orderNumber}`;
    const order = state.orders[orderNumber];
    if (!order) {
        return defaultLink;
    }
    switch (getStatus(order)) {
        case STATUS_PROGRESS:
            return `/myorders/inprogress/${orderNumber}`
        case STATUS_COMPLETE:
            return `/myorders/completed/${orderNumber}`
        default:
            return defaultLink;
    }
};


// WEBPACK FOOTER //
// ./src/utils/order.js